export const RESERVATIONS_BASE = '/reservations';

export type ReservationsTab = 'opentable' | 'links';

const TAB_SLUGS: Record<ReservationsTab, string> = {
  opentable: 'opentable',
  links: 'links',
};

export const reservationsPath = (tab: ReservationsTab) =>
  `${RESERVATIONS_BASE}/${TAB_SLUGS[tab]}`;

const normalizePath = (pathname: string) =>
  pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;

export const resolveReservationsRoute = (
  pathname: string,
): { tab: ReservationsTab | null; redirectTo: string | null } => {
  const normalized = normalizePath(pathname);
  if (
    normalized !== RESERVATIONS_BASE &&
    !normalized.startsWith(`${RESERVATIONS_BASE}/`)
  ) {
    return { tab: null, redirectTo: null };
  }

  const rest =
    normalized === RESERVATIONS_BASE
      ? ''
      : normalized.slice(RESERVATIONS_BASE.length + 1);
  const [section, ...extra] = rest.split('/').filter(Boolean);

  if (!section) {
    return { tab: null, redirectTo: null };
  }
  if (extra.length === 0 && (section === 'opentable' || section === 'links')) {
    return { tab: section, redirectTo: null };
  }
  return { tab: null, redirectTo: RESERVATIONS_BASE };
};
